import axios from 'axios';

export const API = axios.create({
    baseURL: "/v1",
    headers: {
        'X-ZOOZA-API-KEY': 'mZ3qLfNd08',
        'X-ZOOZA-SCOPE': 'downstream',
    }
});



